// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD5YygmbM6WHcHP4lBa38DE-0jAcjuyvHs",
  authDomain: "cotizador-2025.firebaseapp.com",
  projectId: "cotizador-2025",
  storageBucket: "cotizador-2025.firebasestorage.app",
  messagingSenderId: "11772922592",
  appId: "1:11772922592:web:78c461074924adf9b21e85"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
export const auth = getAuth(app);

export { db };